import styled from 'styled-components';

const StiledButton = styled.div`
    font-family: "Montserrat", "serif";
    font-size: 15px;
    font-weight: bold;
    text-align: center;
    color: black;
    background-color: #c58e50;
    border-radius: 25px;
    height: 35px;
    padding-top: 13px;
    float: left;
    margin-right: 15px;
    cursor: pointer;
    &:hover {
        opacity: .9;
    }
`;

const StyledMoreInfoButton= styled(StiledButton)`
    width: 200px;
    color: #ffffea;
`;

const StyledContactUsButton= styled(StiledButton)`
    width: 250px;
    color: #c58e50;
    background-color: #ffffea;
`;

const StyledNavigationButton= styled(StiledButton)`
    width: 200px;
    color: #ffffea;
    float: right;
    margin-top: 25px;
`;

export function MoreInfoButton({label}) {
    return (
        <StyledMoreInfoButton>
            {label}
        </StyledMoreInfoButton>
    );
}

export function ContactUsButton({label}) {
    return (
        <StyledContactUsButton>
            {label}
        </StyledContactUsButton>
    );
}

export function NavigationButton({label}) {
    return (
        <StyledNavigationButton>
            {label}
        </StyledNavigationButton>
    );
}